<template>
  <Breadcrumbs
      title="Dispatch"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Dispatch', path: '/dispatch' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
     <distpatchTable/>
    </div>
  </div>
</template>

<script>
import distpatchTable from './distpatchTable.vue'

export default {
    name: 'indexList',
    components: {
      distpatchTable,
    },
}
</script>